import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import EmbedFormPage from './EmbedFormPage';

const EmbedApp: React.FC = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/embed/:formId" element={<EmbedFormPage />} />
        <Route path="*" element={
          <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-2xl font-bold mb-2">FormBuilder Pro - Embed</h1>
              <p className="text-gray-600">This page displays published forms only.</p>
            </div>
          </div>
        } />
      </Routes>
    </HashRouter>
  );
};

export default EmbedApp;